export const calculateSalesPriceByDiscountPercentage = (listPrice: number, discountPercentage: number): number => {
	return listPrice === 0 ? 0 : listPrice * (1 - discountPercentage / 100);
};
